var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_9141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20005 1.75C8.60005 1.75 10.6 3.75 10.6 6.15C10.6 8.55 8.60005 10.55 6.20005 10.55C3.80005 10.55 1.80005 8.55 1.80005 6.15C1.80005 3.75 3.80005 1.75 6.20005 1.75ZM6.20005 0.25C2.90005 0.25 0.300049 2.85 0.300049 6.15C0.300049 9.45 2.90005 12.05 6.20005 12.05C9.50005 12.05 12.1 9.45 12.1 6.15C12.1 2.85 9.50005 0.25 6.20005 0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7001 13.7499L9.6001 9.6499",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_9141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 13.5,
    fill: "white",
    transform: "translate(0.300049 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/whiteSearch.d3b56136faf4cdf73d66c0647ca8c70e.svg";
export { ForwardRef as ReactComponent };